import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import ItemList from '../../components/admin/ItemList';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

const Items = () => {
  return (
    <AdminLayout>
      <div className="p-8">
        {/* Breadcrumbs */}
        <div className="flex items-center gap-2 mb-8 text-sm">
          <Link to="/kh-admin" className="text-white/70 hover:text-white transition-colors">
            <Home className="w-4 h-4" />
          </Link>
          <ChevronRight className="w-4 h-4 text-white/40" />
          <span className="text-white">Items</span>
        </div>

        <h1 className="text-3xl font-bold mb-8">Items Management</h1>
        <ItemList />
      </div>
    </AdminLayout>
  );
};

export default Items;